import { Button, Stack } from "@mui/material";
import MailOutline from "@mui/icons-material/MailOutline";
import { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { exportFoodProgramEmails } from "../common/api/cfiFoodProgramApplicationApi";
import { ExportCard } from "./ExportCard";

export function FoodExport() {
  const [fromDate, setFromDate] = useState<string>();
  const [toDate, setToDate] = useState<string>();

  return (
    <ExportCard
      id="food-export-title"
      title="Food form emails"
      description="Export food form email addresses for the selected date range."
      icon={<MailOutline />}
      actions={
        <Button
          fullWidth
          variant="contained"
          onClick={() => exportFoodProgramEmails(fromDate, toDate)}
        >
          Export food form emails
        </Button>
      }
    >
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <DatePicker
          label="From"
          format="DD/MM/YYYY"
          value={fromDate ? dayjs(fromDate) : null}
          onChange={(value) => setFromDate(value?.format("YYYY-MM-DD"))}
          slotProps={{ textField: { fullWidth: true, variant: "outlined" } }}
        />
        <DatePicker
          label="To"
          format="DD/MM/YYYY"
          value={toDate ? dayjs(toDate) : null}
          onChange={(value) => setToDate(value?.format("YYYY-MM-DD"))}
          slotProps={{ textField: { fullWidth: true, variant: "outlined" } }}
        />
      </Stack>
    </ExportCard>
  );
}
